
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import Tagify from '@yaireo/tagify'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ulid } from 'ulid';
import { Notyf } from 'notyf';
import { flareVue } from "@flareapp/flare-vue";
import LockSession from './utils/lockSession'

import 'notyf/notyf.min.css';
import '@yaireo/tagify/dist/tagify.css'
import "video.js/dist/video-js.css"


import Vue from 'vue';

window.Swal = Swal
window.ulid = ulid;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('share-markup-form', require('./components/ShareMarkupForm.vue').default);
Vue.component('collaborator-list', require('./components/CollaboratorList.vue').default);
Vue.component('share-link', require('./components/ShareLink.vue').default);
Vue.component('add-collaborator', require('./components/AddCollaborator.vue').default);
Vue.component('floating-comment-form', require('./components/FloatingCommentForm.vue').default);
Vue.component('comment', require('./components/Comment.vue').default);
Vue.component('comments', require('./components/Comments.vue').default);
Vue.component('clipboard', require('./components/Clipboard.vue').default);
Vue.component('clone-markup', require('./components/CloneMarkup.vue').default);
Vue.component('drawer', require('./components/ui/Drawer.vue').default);
Vue.component('icon-sidebar-wrapper', require('./components/IconSidebarWrapper.vue').default);
Vue.component('previewable-image', require('./components/PreviewableImage').default);
Vue.component('color-picker', require('./components/ColorPicker').default);
Vue.component('drag-drop', require('./components/DragDrop.vue').default);
Vue.component('add-to-collection', require('./components/Collections/AddTo.vue').default);
Vue.component('collection-wrapper', require('./components/Collections/CollectionWrapper.vue').default);
Vue.component('collection-panel', require('./components/Collections/Panel.vue').default);
Vue.component('collection-item', require('./components/Collections/CollectionItem.vue').default);
Vue.component('collection-icon-list', require('./components/Collections/IconList.vue').default);
Vue.component('icon-search', require('./components/Collections/Editor/IconSearch.vue').default);
Vue.component('collection-icon-wrapper', require('./components/Collections/Editor/IconWrapper').default);
Vue.component('editor', require('./components/Editor/Editor.vue').default);
Vue.component('editor-word-count', require('./components/Editor/WordCount.vue').default);
Vue.component('stage', require('./components/HelpVideo/Stage.vue').default);
Vue.component('risk-assessment-sidebar', require('./components/Risks/RiskAssessmentSidebar').default);
Vue.component('collapse-tools', require('./components/ui/CollapseTools.vue').default);
Vue.component('floating-element', require('./components/ui/FloatingElement.vue').default);
Vue.component('btn-download-qr', require('./components/DownloadQRCode.vue').default);
Vue.component('markup-collection-form', require('./components/Markups/CreateModal.vue').default);
Vue.component('icon-list-sync-wrapper', require('./components/Markups/IconListSyncWrapper.vue').default);
Vue.component('marker-button', require('./components/ui/MarkerButton.vue').default);

// const files = require.context('./', true, /\.vue$/i)

// files.keys().map(key => {
//     return Vue.component(_.last(key.split('/')).split('.')[0], files(key))
// })

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const notyf = new Notyf({
    duration: 5000 // Set your global Notyf configuration here
});

window.cm = {
    notyf
}

Vue.use(flareVue);

const app = new Vue({
    el: '#app',
    provide: () => {
        return {
            notyf,
        }
    },
    data() {
        return {
            collaborators: []
        }
    },
});

/**
 * Create a tagify instance for the share modal.
 *
 * This waits for the document to load then attaches to the input.
 * The saved output is a CSV value on the form submit for the backend
 */
document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('.tagify')) {
        document.querySelectorAll('.tagify')?.forEach(element => {
            new Tagify(element, {
                originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(',')
            })
        })
    }

    if (window?.savedMarkup?.uuid) {
        new LockSession();
    }

    if (document.querySelector('#nav_markup_name')) {
        let markupId = document.querySelector('#nav_markup_name').dataset.markup
        let editing = false

        document.querySelector('#nav_markup_name')
            .addEventListener('dblclick', function (event) {
                editing = true;
                document.querySelector("#markup_name_status").hidden = editing
                event.target.contentEditable = true;
            });

        document.querySelector('#nav_markup_name')
            .addEventListener('blur', function (event) {
                document.querySelector("#markup_name_status").hidden = false
                axios
                    .patch(
                        `/markup/${markupId}`,
                        {
                            name: event.target.innerText.replaceAll(/\n|\r/g, ''),
                        })
                    .then(function (response) {
                        editing = document.querySelector("#markup_name_status").hidden = true
                    })
                    .catch(function () {
                        editing = document.querySelector("#markup_name_status").hidden = true
                    })
            });

        document.querySelector('#nav_markup_name')
            .addEventListener('keydown', function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault()
                }
            })
    }

    if(window.user?.id) {
        Echo.private(`App.User.${window.user.id}`)
            .listen('.markup.cloned', function () {
                console.debug('received event')
                window.cm.notyf.success('Markup Cloned, refreshing list');
                setTimeout(_ => window.location.reload(), 1000)
            })
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl))
})
